import React, {useMemo} from 'react';


import {UserLink} from 'src/components/links';
import {getUserLabel} from 'src/utils/getUserLabel';
import {splitByCapitalLetters} from 'src/utils/splitByCapitalLetters';
import {toCapitalCase} from 'src/utils/toCapitalCase';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

import type {UserShortInfo} from 'src/openapi/admin/models/UserShortInfo';

type Props = {
    system: string,
    process: string,
    user: UserShortInfo,
};

export const ActionInitiatorCell = ({system, process, user}: Props) => {
    const label: string = useMemo(() => [
        system ? toCapitalCase(system) : null,
        process ? toCapitalCase(splitByCapitalLetters(process)) : null,
    ].join(': '), [system, process]);

    if (user) {
        return (
            <UserLink
                userId={user.userId}
                caption={getUserLabel(user)}
                place="Account Entitlements Change Log"
            />
        );
    }

    return (
        <EllipsisTextHint title={label}>
            <span>
                {system ? <b>{toCapitalCase(system)}</b> : null}
                {process ? `: ${toCapitalCase(splitByCapitalLetters(process))}` : null}
            </span>
        </EllipsisTextHint>
    );
};
